<template>
  <div :style="container_style" :class="container_class">
    <img @click="toggleShow" :style="img_style" :class="img_class" :src="imgDataUrl" />
    <div
      @click="toggleShow"
      style="cursor:pointer;position: absolute;text-align: center;left: 74px;top: 121px;"
    >
      <i class="fa fa-camera" style="position: absolute;" aria-hidden="true"></i>
      <div
        v-show="imgDataUrl=='' || imgDataUrl==null || imgDataUrl == undefined"
        style="position: absolute;width:100px;bottom: 41px;left: -40px;font-weight: 100;text-align: center;"
        aria-hidden="true"
      >{{label}}</div>
    </div>

    <my-upload
      v-if="show"
      field="img"
      @crop-success="cropSuccess"
      @crop-upload-success="cropUploadSuccess"
      @crop-upload-fail="cropUploadFail"
      v-model="show"
      :width="200"
      :height="200"
      :url="'/api/v1/upload/logo?api_token=' + api_token"
      :params="params"
      :headers="headers"
      img-format="png"
      langType="en"
      :noRotate="false"
      :noSquare="false"
      :noCircle="true"
    ></my-upload>
    <img />
  </div>
</template>

<script>
import myUpload from "vue-image-crop-upload";
export default {
  name: "logo",
  components: {
    "my-upload": myUpload
  },
  props: {
    value: {
      type: String,
      default: ""
    },
    logo_url: {
      type: String,
      default: ""
    },
    label: {
      type: String,
      default: "Click here to change logo"
    },
    container_style: {
      type: String,
      default:
        "height: 141px;position: relative;border-radius:10px;box-shadow:0px 1px 7px -3px;"
    },
    container_class: {
      type: String,
      default: ""
    },
    img_style: {
      type: String,
      default:
        "border-radius:50%;width:100px;position:absolute;left:31px;top:10px;"
    },
    img_class: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      show: false,
      params: {
        token: "123456798",
        name: "avatar"
      },
      headers: {
        smail: "*_~"
      },
      imgDataUrl: this.value, // the datebase64 url of created image
      api_token: window.api_token
    };
  },
  methods: {
    toggleShow() {
      this.show = !this.show;
    },
    /**
     * crop success
     *
     * [param] imgDataUrl
     * [param] field
     */
    cropSuccess(imgDataUrl, field) {
      this.imgDataUrl = imgDataUrl;
    },
    /**
     * upload success
     *
     * [param] jsonData  server api return data, already json encode
     * [param] field
     */
    cropUploadSuccess(jsonData, field) {
      this.$emit("input", jsonData.data[600]);
      let self = this;
      setTimeout(function() {
        self.show = false;
      }, 1000);
    },
    /**
     * upload fail
     *
     * [param] status    server api return error status, like 500
     * [param] field
     */
    cropUploadFail(status, field) {
      console.log("-------- upload fail --------");
      console.log(status);
      console.log("field: " + field);
      setTimeout(function() {
        self.show = false;
      }, 1000);
    }
  },
  watch: {
    imgDataUrl: {
      handler() {
        this.$emit("input", this.imgDataUrl);
      }
    }
  }
};
</script>
